import React, { Fragment, useEffect } from 'react'
import { Status } from '../../../hooks/useFetchState'
import {
  GenericTable,
  TableHeaderConfigWithType
} from '../../../components/_EOS/Table'
import { BatchInfo } from '../../../interfaces/Stock/Stock'
import { usePagination } from '../../../hooks/usePagination'
import { useApi } from '../../../hooks/useApi'
import { ApiResponse } from '../../../typings/ApiResponse'
import { GetStockBatchDetailAsync } from '../config/api'
import { Box, Grid, Typography } from '@mui/material'
import { getStyleRow, mapBatchStatusToExpiredColor } from '../../../utils/colors'
import { formatExpirationDate } from '../../../utils/dateHelper'
import { SearchBatchDetail } from '../config/config'

interface BatchDetailMainProps {
  row: SearchBatchDetail
}

const tableHeaders: TableHeaderConfigWithType<BatchInfo>[] = [
  {
    field: 'expires',
    title: 'Expira',
    sortable: false,
    formater: (expirationDate: unknown) =>
      formatExpirationDate(expirationDate as string, 'dd-MM-yyyy')
  },
  {
    field: 'batchNumber',
    title: 'Lote',
    sortable: false
  },
  {
    field: 'qty',
    title: 'Cantidad',
    sortable: false
  }
]

export const BatchDetailMain: React.FC<BatchDetailMainProps> = ({ row }) => {
  const pagination = usePagination(5)
  const { state, callApi } = useApi<ApiResponse<BatchInfo>>()

  const requestApi = (page?: number, pageSize?: number) => {
    callApi(
      GetStockBatchDetailAsync(
        row.stockKeepingUnitId,
        row.positionId,
        page,
        pageSize
      )
    ).catch((error) => {
      console.log(error)
    })
  }

  const handlePaginationChange = (page: number, pageSize: number) => {
    const auxPage = pagination.pageSize !== pageSize ? 0 : page
    requestApi(auxPage, pageSize)
    pagination.setPagination(auxPage, pageSize)
  }

  useEffect(() => {
    requestApi(0, pagination.pageSize)
  }, [])

  // Mapear y usar el utilitario centralizado de colores
  const getRowStyle = (batchState: number) => {
    return getStyleRow(mapBatchStatusToExpiredColor(batchState))
  }

  return (
    <Fragment>
      <Grid container spacing={3} alignItems='center'>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant='body2'>
            <Box component='span' fontWeight='bold'>
              SKU:
            </Box>{' '}
            {row.sku}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant='body2'>
            <Box component='span' fontWeight='bold'>
              POSICIÓN:
            </Box>{' '}
            {row.positionCode}
          </Typography>
        </Grid>
      </Grid>

      <GenericTable<BatchInfo>
        rowConfig={state.data?.items.map((el) => getRowStyle(el?.batchState)) as any}
        headersConfig={tableHeaders}
        IDKey={'id'}
        data={state.data?.items}
        pagination={{
          totalItem: state.data?.totalItems || 0,
          page: pagination.page,
          pageSize: pagination.pageSize
        }}
        onPaginationChange={handlePaginationChange}
        isLoading={state.status === Status.Loading}
      />
    </Fragment>
  )
}
